/**
 * SERAF — Quick add pour les best-sellers du cart drawer.
 */
(function () {
  const SOURCE = 'seraf-cart-recos';
  const CART_UPDATED = 'cart:updated';

  function getCartDrawerSectionId() {
    return document.querySelector('cart-drawer')?.dataset?.sectionId || null;
  }

  function buildSectionsPayload() {
    var sectionId = getCartDrawerSectionId();
    if (!sectionId) return {};
    return {
      sections: sectionId,
      sections_url: window.location.pathname,
    };
  }

  function dispatchCartUpdated(payload) {
    document.dispatchEvent(
      new CustomEvent(CART_UPDATED, {
        bubbles: true,
        detail: {
          resource: {},
          data: payload,
        },
      }),
    );
  }

  function hideProductCard(handle) {
    if (!handle) return;
    document.querySelectorAll('.seraf-cart-recos__product[data-product-handle="' + handle + '"]').forEach(function (card) {
      card.classList.add('hidden');
    });

    document.querySelectorAll('.seraf-cart-recos').forEach(function (block) {
      var visible = block.querySelectorAll('.seraf-cart-recos__product:not(.hidden)');
      if (!visible.length) block.classList.add('hidden');
    });
  }

  function syncWithCartItems() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    drawer.querySelectorAll('[data-ref="cart-item"]').forEach(function (item) {
      hideProductCard(item.dataset.productHandle);
    });
  }

  async function addVariant(button) {
    var variantId = button.dataset.variantId;
    if (!variantId || button.disabled || button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    button.disabled = true;

    try {
      var payload = Object.assign(
        {
          items: [{ id: Number(variantId), quantity: 1 }],
        },
        buildSectionsPayload(),
      );

      var response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify(payload),
      });

      var data = await response.json();
      if (!response.ok) throw new Error(data?.description || 'add failed');

      var currentCount = document.querySelector('cart-icon')?.getCurrentItemCount?.();
      var nextCount = typeof currentCount === 'number' ? currentCount + 1 : data.item_count;

      dispatchCartUpdated({
        itemCount: nextCount,
        source: SOURCE,
        sections: data.sections,
      });
    } catch (error) {
      console.warn('[seraf-cart-recos]', error);
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-seraf-reco-add]');
    if (!button || !button.closest('.seraf-cart-recos')) return;

    event.preventDefault();
    event.stopPropagation();
    addVariant(button);
  });

  document.addEventListener(CART_UPDATED, function () {
    syncWithCartItems();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncWithCartItems);
  } else {
    syncWithCartItems();
  }
})();
